<template>
  <div class="page-container city-choose">
    <ucar-title type="model" @close="close" ref="header">选择城市</ucar-title>
    <div class="city-choose-header" ref="currentCity" v-if="value.name" @click="close">当前选择城市：{{value.name}}</div>
    <ul class="city-choose-slider">
      <li
        v-for="item in flags"
        :key="item"
        :class="{ 'hot': item === '热门' }"
        @click="jump(item)"
      >{{item}}</li>
    </ul>
    <div class="city-choose-wrapper" ref="listDom"  v-scroll:brand="currentIndex">
      <div class="city-choose-body">
        <div class="hot-cities" v-if="list.length > 0 && list[0].flag === '热门' && list[0].cities && list[0].cities.length > 0">
          <div class="hot-cities-title" id="热门" ref="热门">热门城市</div>
          <ul class="hot-cities-body">
            <li v-for="item in list[0].cities" :key="item.name" @click="choose(item)">{{item.name}}</li>
          </ul>
        </div>
        <div class="cities-group" v-for="item in list.filter(item => item.flag !== '热门')" :key="item.flag">
          <div class="cities-group-title" :id="item.flag" :ref="item.flag">{{item.flag}}</div>
          <ul class="cities-group-list">
            <li
              v-for="subItem in item.cities"
              :key="subItem.name"
              @click="choose(subItem)"
            >{{subItem.name}}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="stylus" scoped>
@import "../styles/variable.styl";

.city-choose {
  position: fixed;
  text-align: left;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  height: 100%;
  z-index: 999;
  display: flex;
  flex-flow: column nowrap;

  .city-choose-wrapper {
    flex: 1 1 0;
    overflow: hidden;
    touch-action: none;
  }

  .city-choose-header {
    height: 88px;
    line-height: 84px;
    padding: 0 30px;
    color: $ucar_font_color;
    font-size: $ucar_font_h4;
  }

  ul.city-choose-slider {
    padding: 0;
    list-style: none;
    position: absolute;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center;
    top: 0;
    bottom: 0;
    right: 0;
    width: 50px;
    color: $ucar_main_color;
    font-size: $ucar_font_h6;
    z-index: 1000;

    li {
      white-space: nowrap;
      font-size: $ucar_font_h6;
      line-height: 35px;
      height: 35px;
      color: $ucar_main_color;

      &.hot {
        font-size: 14px;
      }
    }
  }

  .city-choose-body {
    position: relative;
    padding-right: 50px;

    .hot-cities {
      background-color: $ucar_body_bg;
      color: $ucar_font_color;
      padding: 30px 0 0 30px;

      .hot-cities-title {
        padding: 20px 0;
        background-color: $ucar_body_bg;
        color: $ucar_alert_color;
        font-size: $ucar_font_h5;
        line-height: $ucar_font_h5;
      }

      ul.hot-cities-body {
        list-style: none;
        padding: 0;

        li {
          display: inline-block;
          border: 1px solid $ucar_light_border; /*no*/
          background-color: #fff;
          height: 88px;
          width: 196px;
          text-align: center;
          line-height: 84px;
          font-size: $ucar_font_h4;
          margin: 0 20px 20px 0;
        }
      }
    }

    .cities-group {
      .cities-group-title {
        line-height: $ucar_font_h5;
        background-color: $ucar_body_bg;
        color: $ucar_alert_color;
        padding: 20px 0 20px 30px;
        font-size: $ucar_font_h5;
      }

      ul.cities-group-list {
        padding-left: 30px;
        background-color: #fff;

        li {
          height: 88px;
          line-height: 84px;
          color: $ucar_font_color;
          font-size: $ucar_font_h4;
          border-bottom: 1px solid $ucar_light_border; /*no*/

          &:last-child {
            border-bottom: none;
          }
        }
      }
    }
  }
}
</style>

<script>
import Iscroll from 'iscroll'
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    value: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      currentIndex: ''
    }
  },
  directives: {
    scroll: {
      inserted (el, binding, vnode) {
        vnode.scroll = new Iscroll(el, {
          click: true
        })
      },
      componentUpdated (el, binding, vnode, oldVnode) {
        vnode.scroll = oldVnode.scroll
        vnode.scroll.refresh()
        if (binding.value && binding.value !== vnode.scroll.scrollPosition) {
          vnode.scroll.scrollToElement(`[id="${binding.value}"]`, 300)
          vnode.scroll.scrollPosition = binding.value
        }
      },
      unbind (el, binding, vnode, oldVnode) {
        vnode.scroll = oldVnode.scroll
        vnode.scroll.destroy()
        vnode.scroll = null
      }
    }
  },
  computed: {
    flags () {
      return this.list.map(item => item.flag)
    }
  },
  methods: {
    jump (flag) {
      this.currentIndex = flag
    },
    choose (val) {
      this.$emit('change', val)
    },
    close () {
      this.$emit('change')
    }
  }
}
</script>
